import { NAVIGATION } from "@/constants";
import * as NavigationMenuPrimitive from "@radix-ui/react-navigation-menu";
import { useIsCurrentPageNumber } from "../../hooks/useIsCurrentPageNumber";
import { DropdownMenuItem } from "./DropdownMenuItem";
import { NavigationIcon } from "./NavigationIcon";
import { NavigationLink } from "./NavigationLink";
import { getItemClassName } from "./utils";

export const NavigationMenu = () => {
  const isCurrentPageName = useIsCurrentPageNumber();

  return (
    <NavigationMenuPrimitive.Root
      skipDelayDuration={0}
      delayDuration={0}
      className="flex w-full items-center gap-4"
    >
      <NavigationMenuPrimitive.List className="flex items-center gap-4">
        {NAVIGATION.map((item) =>
          item.items ? (
            <DropdownMenuItem
              isCurrentPageName={isCurrentPageName(item)}
              key={item.name}
              item={item}
              animatedTitleOnHover={item.name === "Evaluate"}
            />
          ) : (
            <NavigationLink to={item.href!}>
              <NavigationMenuPrimitive.Item
                className={getItemClassName(
                  isCurrentPageName(item),
                  "group inline-flex cursor-pointer items-center gap-2 rounded-md px-3 py-2 text-sm",
                )}
                key={item.name}
              >
                <NavigationIcon icon={item.icon} />
                <span className="hidden truncate text-xs font-medium text-gray-900 2xl:ml-2 2xl:block 2xl:text-sm">
                  {item.name}
                </span>
                <span className="ml-0 block max-w-0 overflow-hidden whitespace-nowrap text-xs font-medium text-gray-900 opacity-0 transition-all duration-200 group-hover:ml-2 group-hover:max-w-[120px] group-hover:opacity-100 group-focus:ml-2 group-focus:max-w-[120px] group-focus:opacity-100 2xl:hidden">
                  {item.name}
                </span>
              </NavigationMenuPrimitive.Item>
            </NavigationLink>
          ),
        )}
      </NavigationMenuPrimitive.List>
    </NavigationMenuPrimitive.Root>
  );
};
